const openmodal = document.querySelectorAll('[data-modal-open]');
for (var i = 0; i < openmodal.length; i++) {
    openmodal[i].addEventListener('click', (event) => {
        const modal = event.target.closest('.modal-open').getAttribute('data-modal-open');
        event.preventDefault();
        toggleModal(modal);
    });
}

const overlay = document.querySelectorAll('.modal-overlay');
if (overlay != null) {
  for (var i = 0; i < overlay.length; i++) {
    overlay[i].addEventListener('click', (event) => {
      const modal = event.target.getAttribute('data-modal-overlay');
      event.preventDefault();
      toggleModal(modal);
    });
  }
}

const closemodal = document.querySelectorAll('.modal-close');
for (var i = 0; i < closemodal.length; i++) {
    closemodal[i].addEventListener('click', (event) => {
    const modal = event.target.closest('.modal').getAttribute('data-modal');
    event.preventDefault();
    toggleModal(modal);
  });
}

function toggleModal(clickedElement) {
    const body = document.querySelector('body');
    const modal = document.querySelector(`[data-modal=${clickedElement}]`);
    modal.classList.toggle('opacity-0');
    modal.classList.toggle('pointer-events-none');
    body.classList.toggle('modal-active');
}
